import { Label, Select, TextInput, Textarea } from "flowbite-react";

export const LIEN_STATUS_OPTIONS = ["OPEN", "RELEASED", "UNKNOWN"];

export default function LienFormFields({
  form,
  onChange,
  notesPlaceholder = "Observações...",
}) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
      <div>
        <Label>Lien Type</Label>
        <TextInput
          value={form.lien_type || ""}
          onChange={(event) => onChange({ lien_type: event.target.value })}
          placeholder="Ex: Mortgage / HOA / IRS"
        />
      </div>

      <div>
        <Label>Amount (USD)</Label>
        <TextInput
          type="text"
          inputMode="decimal"
          value={form.amount ?? ""}
          onChange={(event) => onChange({ amount: event.target.value })}
          placeholder="Ex: 1250.00"
        />
      </div>

      <div>
        <Label>Recorded At</Label>
        <TextInput
          type="date"
          value={form.recorded_at || ""}
          onChange={(event) => onChange({ recorded_at: event.target.value })}
        />
      </div>

      <div>
        <Label>Status</Label>
        <Select
          value={form.status || "UNKNOWN"}
          onChange={(event) => onChange({ status: event.target.value })}
        >
          {LIEN_STATUS_OPTIONS.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </Select>
      </div>

      <div className="md:col-span-2">
        <Label>Source URL</Label>
        <TextInput
          value={form.source_url || ""}
          onChange={(event) => onChange({ source_url: event.target.value })}
          placeholder="https://..."
        />
      </div>

      <div className="md:col-span-3">
        <Label>Notes</Label>
        <Textarea
          rows={3}
          value={form.notes || ""}
          onChange={(event) => onChange({ notes: event.target.value })}
          placeholder={notesPlaceholder}
        />
      </div>
    </div>
  );
}
